import { useEffect, Dispatch, SetStateAction } from 'react';
import { Article, User } from '../types';
import { ArticleService } from '../services/articleService';

export default function useArticleLiveUpdates(user: User | null | undefined, setArticles: Dispatch<SetStateAction<Article[]>>) {
  useEffect(() => {
    if (!user) return;
    return ArticleService.subscribeToUpdates(user, updated => {
      setArticles(previous => previous.map(article => article.id === updated.id ? updated : article));
    });
  }, [user, setArticles]);
}
